/* custom-marquee.js — infinite auto-scrolling strip for custom-perks-bar.
   [data-custom-marquee] sections get their [data-custom-marquee-track]
   content cloned once (cloneNode, not a duplicated Liquid render, so
   Shopify block IDs in the DOM stay unique for the editor) to build a
   seamless loop, then animated via a CSS custom property duration derived
   from the section's data-speed (px/sec) and the track's measured width.
   Skips entirely when the visitor prefers reduced motion. */
(function () {
  /** @param {HTMLElement} el */
  function initMarquee(el) {
    if (el.dataset.marqueeInit) return;
    el.dataset.marqueeInit = '1';

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    var trackEl = el.querySelector('[data-custom-marquee-track]');
    var innerEl = el.querySelector('[data-custom-marquee-inner]');
    if (!trackEl || !innerEl) return;
    var track = trackEl;
    var inner = innerEl;

    var clone = /** @type {Element} */ (track.cloneNode(true));
    clone.setAttribute('aria-hidden', 'true');
    inner.appendChild(clone);

    var speed = parseFloat(el.dataset.speed || '') || 60;

    function measure() {
      /* Distance is the offset between the original track and its clone
         (track width + the --custom-pb-gap between them), not just the
         track's own width — otherwise the loop skips that gap on reset
         and stutters right at the seam. */
      var distance = clone.getBoundingClientRect().left - track.getBoundingClientRect().left;
      if (!distance) return;
      var duration = distance / speed;
      el.style.setProperty('--custom-pb-duration', duration + 's');
      el.style.setProperty('--custom-pb-distance', '-' + distance + 'px');
    }

    measure();
    window.addEventListener('resize', measure);
  }

  function init() {
    document.querySelectorAll('[data-custom-marquee]').forEach(function (el) {
      initMarquee(/** @type {HTMLElement} */ (el));
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
